import * as React from 'react';

function HowSkillSetsWork3(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={340} height={136} viewBox="0 0 340 136" fill="none" {...props}>
      <path fill="var(--cds-color-grey-25)" d="M0 0h340v136H0z" />
      <mask id="prefix__a" fill="var(--cds-color-neutral-primary-invert)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110.686 35.658l-7.128-5.384a1.277 1.277 0 00-1.58 0l-7.277 5.496c-.087.067-.169.144-.243.23H64a5 5 0 000 10h31.27l6.55 4.947a1.277 1.277 0 001.58 0L109.95 46H160a5 5 0 000-10h-48.982a1.566 1.566 0 00-.332-.342z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.686 35.658l-7.128-5.384a1.277 1.277 0 00-1.58 0l-7.277 5.496c-.087.067-.169.144-.243.23H64a5 5 0 000 10h31.27l6.55 4.947a1.277 1.277 0 001.58 0L109.95 46H160a5 5 0 000-10h-48.982a1.566 1.566 0 00-.332-.342z"
        fill="var(--cds-color-neutral-primary-invert)"
      />
      <path
        d="M103.558 30.274l.603-.798-.603.798zm7.128 5.384l-.602.798.602-.798zm-8.708-5.384l-.603-.798.603.798zm-7.277 5.496l-.602-.798.602.798zm-.243.23v1h.46l.299-.349-.76-.651zm.812 10l.603-.798-.268-.202h-.335v1zm6.55 4.947l.602-.797-.602.797zm1.58 0l-.603-.797.603.797zM109.95 46v-1h-.336l-.267.202.603.798zm1.068-10l-.812.583.299.417h.513v-1zm-8.062-4.928l7.128 5.384 1.205-1.596-7.128-5.384-1.205 1.596zm-.375 0c.126-.096.248-.096.375 0l1.205-1.596a2.277 2.277 0 00-2.786 0l1.206 1.596zm-7.277 5.496l7.277-5.496-1.206-1.596-7.276 5.496 1.205 1.596zm-.087.083a.563.563 0 01.087-.083L94.1 34.972c-.148.112-.281.238-.4.377l1.518 1.302zM64 37h30.458v-2H64v2zm-4 4a4 4 0 014-4v-2a6 6 0 00-6 6h2zm4 4a4 4 0 01-4-4h-2a6 6 0 006 6v-2zm31.27 0H64v2h31.27v-2zm7.152 5.15l-6.55-4.948-1.205 1.596 6.55 4.947 1.205-1.595zm.375 0c-.126.095-.248.095-.375 0l-1.205 1.596c.84.634 1.946.634 2.786 0l-1.206-1.596zm6.55-4.948l-6.55 4.948 1.206 1.596 6.549-4.948-1.205-1.596zM160 45h-50.05v2H160v-2zm4-4a4 4 0 01-4 4v2a6 6 0 006-6h-2zm-4-4a4 4 0 014 4h2a6 6 0 00-6-6v2zm-48.982 0H160v-2h-48.982v2zm-.934-.544a.596.596 0 01.122.127l1.624-1.166a2.582 2.582 0 00-.541-.557l-1.205 1.596z"
        fill="var(--cds-color-grey-200)"
        mask="url(#prefix__a)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.5 42.75l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L102.5 36l1.323 2.68 2.957.43-2.14 2.085.505 2.946-2.645-1.391z"
        fill="var(--cds-color-yellow-200)"
      />
      <path d="M61 41a3 3 0 013-3h23.4v6H64a3 3 0 01-3-3z" fill="var(--cds-color-yellow-200)" />
      <mask id="prefix__b" fill="var(--cds-color-neutral-primary-invert)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M88.686 90.658l-7.128-5.384a1.278 1.278 0 00-1.58 0L72.7 90.77c-.087.067-.169.144-.243.23H64a5 5 0 000 10h9.27l6.55 4.948a1.28 1.28 0 001.58 0L87.95 101H160a5 5 0 000-10H89.018a1.584 1.584 0 00-.332-.342z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M88.686 90.658l-7.128-5.384a1.278 1.278 0 00-1.58 0L72.7 90.77c-.087.067-.169.144-.243.23H64a5 5 0 000 10h9.27l6.55 4.948a1.28 1.28 0 001.58 0L87.95 101H160a5 5 0 000-10H89.018a1.584 1.584 0 00-.332-.342z"
        fill="var(--cds-color-neutral-primary-invert)"
      />
      <path
        d="M81.558 85.274l.603-.798-.603.798zm7.128 5.384l.603-.798-.603.798zm-8.708-5.384l-.603-.798.603.798zM72.7 90.77l-.602-.798.602.798zm-.243.23v1h.46l.299-.349-.76-.651zm.812 10l.603-.798-.268-.202h-.335v1zm6.55 4.948l.602-.798-.602.798zm1.58 0l-.603-.798.603.798zM87.95 101v-1h-.336l-.267.202.603.798zm1.068-10l-.812.583.299.417h.513v-1zm-8.063-4.928l7.129 5.384 1.205-1.596-7.128-5.384-1.206 1.596zm-.374 0c.126-.096.248-.096.374 0l1.206-1.596a2.277 2.277 0 00-2.786 0l1.206 1.596zm-7.277 5.496l7.277-5.496-1.206-1.596-7.276 5.496 1.205 1.596zm-.087.083a.563.563 0 01.087-.083L72.1 89.972c-.148.112-.281.238-.4.377l1.518 1.302zM64 92h8.458v-2H64v2zm-4 4a4 4 0 014-4v-2a6 6 0 00-6 6h2zm4 4a4 4 0 01-4-4h-2a6 6 0 006 6v-2zm9.27 0H64v2h9.27v-2zm7.152 5.15l-6.55-4.948-1.205 1.596 6.55 4.947 1.205-1.595zm.375 0c-.126.095-.248.095-.375 0l-1.205 1.595c.84.635 1.946.635 2.786 0l-1.206-1.595zm6.55-4.948l-6.55 4.948 1.206 1.595 6.55-4.947-1.206-1.596zM160 100H87.95v2H160v-2zm4-4a4 4 0 01-4 4v2a6 6 0 006-6h-2zm-4-4a4 4 0 014 4h2a6 6 0 00-6-6v2zm-70.982 0H160v-2H89.018v2zm-.934-.544a.588.588 0 01.122.127l1.624-1.166a2.586 2.586 0 00-.54-.557l-1.206 1.596z"
        fill="var(--cds-color-grey-200)"
        mask="url(#prefix__b)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.5 97.75l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L80.5 91l1.323 2.68 2.957.43-2.14 2.085.505 2.946L80.5 97.75z"
        fill="var(--cds-color-yellow-200)"
      />
      <path d="M61 96a3 3 0 013-3h6v6h-6a3 3 0 01-3-3z" fill="var(--cds-color-yellow-200)" />
      <mask id="prefix__c" fill="var(--cds-color-neutral-primary-invert)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M150.219 63l-6.661-4.742a1.339 1.339 0 00-1.58 0L135.317 63H64a5 5 0 000 10h71.159l6.661 4.742a1.339 1.339 0 001.58 0L150.061 73H160a5 5 0 000-10h-9.781z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M150.219 63l-6.661-4.742a1.339 1.339 0 00-1.58 0L135.317 63H64a5 5 0 000 10h71.159l6.661 4.742a1.339 1.339 0 001.58 0L150.061 73H160a5 5 0 000-10h-9.781z"
        fill="var(--cds-color-neutral-primary-invert)"
      />
      <path
        d="M143.558 58.258l-.58.815.58-.815zM150.219 63l-.58.815.261.185h.319v-1zm-8.241-4.742l.58.815-.58-.815zM135.317 63v1h.32l.26-.185-.58-.815zm-.158 10l.58-.815-.261-.185h-.319v1zm6.661 4.742l-.58.815.58-.815zm1.58 0l-.58-.815.58.815zM150.061 73v-1h-.32l-.26.185.58.815zm-7.083-13.927l6.661 4.742 1.16-1.63-6.661-4.742-1.16 1.63zm-.42 0a.34.34 0 01.42 0l1.16-1.63a2.339 2.339 0 00-2.74 0l1.16 1.63zm-6.661 4.742l6.661-4.742-1.16-1.63-6.661 4.742 1.16 1.63zM64 64h71.317v-2H64v2zm-4 4a4 4 0 014-4v-2a6 6 0 00-6 6h2zm4 4a4 4 0 01-4-4h-2a6 6 0 006 6v-2zm71.159 0H64v2h71.159v-2zm7.24 4.927l-6.66-4.742-1.16 1.63 6.661 4.742 1.159-1.63zm.421 0a.341.341 0 01-.421 0l-1.159 1.63c.83.59 1.91.59 2.74 0l-1.16-1.63zm6.661-4.742l-6.661 4.742 1.16 1.63 6.661-4.742-1.16-1.63zM160 72h-9.939v2H160v-2zm4-4a4 4 0 01-4 4v2a6 6 0 006-6h-2zm-4-4a4 4 0 014 4h2a6 6 0 00-6-6v2zm-9.781 0H160v-2h-9.781v2z"
        fill="var(--cds-color-grey-200)"
        mask="url(#prefix__c)"
      />
      <path d="M61 68a3 3 0 013-3h74v6H64a3 3 0 01-3-3z" fill="var(--cds-color-yellow-200)" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.151 61.18l5.332 3.553c.351.233.533.64.516 1.05v4.41c.001.216-.058.434-.174.63a1.15 1.15 0 01-.349.37l-5.444 3.627c-.361.24-.821.24-1.182 0l-5.333-3.553a1.2 1.2 0 01-.515-1.074v-4.41c.004-.208.062-.417.173-.606.089-.15.209-.276.35-.37l5.443-3.627a1.06 1.06 0 011.183 0z"
        fill="var(--cds-color-yellow-200)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142.5 69.75l-2.645 1.39.505-2.945-2.14-2.086 2.957-.43L142.5 63l1.323 2.68 2.957.43-2.14 2.085.505 2.946-2.645-1.391z"
        fill="var(--cds-color-neutral-primary-invert)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M196 97.833h74v-3.084h-70.917V36.166H196v61.667zm11.122-18.681l2.423 1.904 15.978-20.335 18.543 15.452 24.095-32.93-2.488-1.82L243.517 71.7 225.059 56.32l-17.937 22.832z"
        fill="var(--cds-color-blue-700)"
      />
    </svg>
  );
}

export default HowSkillSetsWork3;
